import { useLocation } from "react-router";

import { getBreadcrumbArticleRoute } from "@/utils/getBreadcrumbRoute";

import Article from "@/components/Article";
import Breadcrumb from "@/components/UI-Kit/Breadcrumb";
import { Container } from "@mui/material";

const ArticleDetails = () => {
  const location = useLocation();
  // Get breadcrumbs data
  const breadcrumbOptions = getBreadcrumbArticleRoute(location);

  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <Breadcrumb options={breadcrumbOptions} />
      </Container>
      <Article />
    </>
  );
};

export default ArticleDetails;
